module.exports = "/packs/media/images/career-ba0d679f670bb3e769c6ce452b384a18.png";